import { Button, Icon, Box, useBreakpointValue } from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
	// Use breakpoint value to set button size
	const buttonSize = useBreakpointValue({ base: 'xs', md: 'smd' });
	const isMobile = useBreakpointValue({ base: true, md: false });
	const getPaginationButtons = () => {
		const buttons = [];
		const maxButtons = isMobile ? 3 : 5;

		let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
		let endPage = Math.min(totalPages, startPage + maxButtons - 1);

		// Adjust startPage and endPage if they exceed limits
		if (endPage - startPage + 1 < maxButtons) {
			startPage = Math.max(1, endPage - maxButtons + 1);
		}

		if (startPage > 1) {
			buttons.push(
				<Button
					key="first"
					onClick={() => onPageChange(1)}
					mx={1}
					size={buttonSize}
					bg={"#FEEFDD"}
					color="black"
					_hover={{ bg: "#FF684B", color: "white" }}
				>
					1
				</Button>
			);
			if (startPage > 2) {
				buttons.push(
					<Button
						key="dots1"
						disabled
						mx={1}
						size={buttonSize}
						bg={"#FEEFDD"} // Background color for ellipsis
						color={"black"} // Color for ellipsis
					>
						...
					</Button>
				);
			}
		}

		for (let i = startPage; i <= endPage; i++) {
			buttons.push(
				<Button
					key={i}
					onClick={() => onPageChange(i)}
					mx={1}
					size={buttonSize}
					bg={i === currentPage ? '#FF684B' : '#FEEFDD'}
					color={i === currentPage ? 'white' : 'black'}
					_hover={{ bg: "#FF684B", color: "white" }}
				>
					{i}
				</Button>
			);
		}

		if (endPage < totalPages) {
			if (endPage < totalPages - 1) {
				buttons.push(
					<Button
						key="dots2"
						disabled
						mx={1}
						size={buttonSize}
						bg={"#FEEFDD"} // Background color for ellipsis
						color={"black"} // Color for ellipsis
					>
						...
					</Button>
				);
			}
			buttons.push(
				<Button
					key="last"
					onClick={() => onPageChange(totalPages)}
					mx={1}
					size={buttonSize}
					bg={"#FEEFDD"}
					color="black"
					_hover={{ bg: "#FF684B", color: "white" }}
				>
					{totalPages}
				</Button>
			);
		}

		if (currentPage > 1) {
			buttons.unshift(
				<Button
					key="prev"
					onClick={() => onPageChange(currentPage - 1)}
					mx={1}
					size={buttonSize}
					bg={"#FEEFDD"}
					color="black" // Default color
					_hover={{ bg: "#FF684B", color: "white" }} // Hover color
				>
					<Icon as={FaArrowLeft} color="#FF684B" _hover={{ color: "white" }} /> {/* Arrow color */}
				</Button>
			);
		}

		if (currentPage < totalPages) {
			buttons.push(
				<Button
					key="next"
					onClick={() => onPageChange(currentPage + 1)}
					mx={1}
					size={buttonSize}
					bg={"#FEEFDD"}
					color="black" // Default color
					_hover={{ bg: "#FF684B", color: "white" }} // Hover color
				>
					<Icon as={FaArrowRight} color="#FF684B" _hover={{ color: "white" }} /> {/* Arrow color */}
				</Button>
			);
		}

		return buttons;
	};

	return (
		<Box display="flex" flexWrap="wrap" justifyContent="center">
			{getPaginationButtons()}
		</Box>
	);
};

export default Pagination;
